// Chave usada em sessionStorage para redirecionar o usuário após o login.
// Consumida em src/app/Routes.js (rota /auth) via sanitizeInternalPath.
export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";
